(function () {
  var holder = document.querySelector('[data-aff-data]');
  var grid = document.querySelector('.product-grid');
  if (!holder || !grid) { return; }

  var data = {};
  try { data = JSON.parse(holder.textContent); } catch (e) { return; }

  var items = Array.prototype.slice.call(grid.children).map(function (el) {
    var a = (el.matches && el.matches('a[href*="/products/"]')) ? el : el.querySelector('a[href*="/products/"]');
    var h = null;
    if (a) {
      h = a.getAttribute('href').split('/products/')[1];
      if (h) { h = h.split('?')[0].split('#')[0]; }
    }
    return { el: el, d: (h && data[h]) ? data[h] : null };
  });

  var sels = {};
  Array.prototype.forEach.call(document.querySelectorAll('[data-aff]'), function (s) {
    sels[s.getAttribute('data-aff')] = s;
  });
  var count = document.querySelector('[data-aff-count]');
  var clear = document.querySelector('[data-aff-clear]');
  var empty = document.querySelector('[data-aff-empty]');

  /* o nome do parametro na URL e o que o menu suspenso usa nos links —
     mudar aqui quebra o menu, os dois precisam andar juntos. */
  var PARAM = { l: 'linha', t: 'tipo', p: 'pele', n: 'need' };

  function val(k) { return sels[k] ? sels[k].value : ''; }

  function apply() {
    var l = val('l'), t = val('t'), p = val('p'), n = val('n'), qtd = 0;
    items.forEach(function (it) {
      var d = it.d || { l: '', t: '', p: [], n: [] };
      var peles = d.p || [];
      var necs = d.n || [];
      /* correspondencia estrita: o produto precisa declarar aquele tipo de pele.
         "Todos os tipos" nao entra como coringa — se entrasse, quase todo o catalogo
         responderia a qualquer filtro e a escolha deixaria de filtrar. */
      var ok = (!l || d.l === l) && (!t || d.t === t) &&
               (!p || peles.indexOf(p) >= 0) && (!n || necs.indexOf(n) >= 0);
      it.el.style.display = ok ? '' : 'none';
      if (ok) { qtd++; }
    });
    if (count) { count.textContent = qtd + (qtd === 1 ? ' produto' : ' produtos'); }
    if (clear) { clear.hidden = !(l || t || p || n); }
    if (empty) { empty.hidden = qtd > 0; }

    var q = [];
    Object.keys(PARAM).forEach(function (k) {
      var v = val(k);
      if (v) { q.push(PARAM[k] + '=' + encodeURIComponent(v)); }
    });
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', q.length ? location.pathname + '?' + q.join('&') : location.pathname);
    }
  }

  function preset() {
    if (!window.URLSearchParams) { return; }
    var q = new URLSearchParams(location.search);
    Object.keys(PARAM).forEach(function (k) {
      var v = q.get(PARAM[k]);
      if (v && sels[k]) {
        var found = Array.prototype.some.call(sels[k].options, function (o) { return o.value === v; });
        if (found) { sels[k].value = v; }
      }
    });
  }

  Object.keys(sels).forEach(function (k) { sels[k].addEventListener('change', apply); });
  if (clear) {
    clear.addEventListener('click', function () {
      Object.keys(sels).forEach(function (k) { sels[k].value = ''; });
      apply();
    });
  }
  preset();
  apply();
})();
